import { SurveyTranslation } from '@tm/shared-lib/src/i18n'
import { createContext } from 'react'
export type TranslationsContextState = {
  surveyLanguages: SurveyTranslation[]
  lang: string
  useDefault?: boolean
  fallbackToMainLang?: boolean
}
export const TranslationsContext = createContext<TranslationsContextState | undefined>(undefined)
